import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useState } from "react";
import Button from "components/Button";
import CloseIcon from "assets/icons/close.svg?react";
import RichEditor from "components/RichEditor";
import Input from "components/Input";
import adminService from "api/adminService";
import { useTranslation } from "react-i18next";

const AddNoteModal: FC<Props> = ({
  addressBookVerificationId,
  toggle,
  refetch,
}) => {
  const { t } = useTranslation();
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");

  const { mutate: addNoteS } =
    adminService.useAddAddressBookVerificationNote();

  const handleCreate = async () => {
    addNoteS(
      {
        ContactFormAddressBookVerificationId: addressBookVerificationId,
        Content: content,
        Title: title,
      },
      {
        onSuccess: () => {
          refetch();
          toggle();
        },
      }
    );
  };

  return (
    <div className={styles.window}>
      <div className={styles.title}>
        {t("modals.note")}
        <CloseIcon onClick={toggle} className={styles.icon} />
      </div>
      <div className={styles.wrapper}>
        <div className={styles.inputs}>
          <Input
            onChange={(a) => setTitle(a)}
            value={title}
            label={t("forms.titleColon")}
          />
        </div>
        <div className={styles.editor}>
          <RichEditor setContent={setContent} content={content} />
        </div>
        <div className={styles.button}>
          <Button onClick={() => handleCreate()} text={t("common.save")} />
        </div>
      </div>
    </div>
  );
};

export default AddNoteModal;
